import React from 'react'
import { Col, Row } from 'reactstrap';

const Selected = () => {
    return (
        <React.Fragment>
            <Row className="align-items-center">
              <Col lg={8}>
    <div className="d-flex align-items-center justify-content-between p-3  rb-4 mb-lg-0 shadow-sm">
        <div className="d-flex align-items-center gap-2">
            <div className="p-2 bg-primary bg-opacity-10 rounded-2 text-primary">
                <i className="uil uil-briefcase-alt fs-4 line-height-0"></i> 
                {/* Note: Swap with your theme's icon class if not using Unicons */}
            </div>
            <div>
                <h5 className="text-dark fw-bold mb-0">Total Applied Jobs</h5>
                <small className="text-muted">Track your recent career applications</small>
            </div>
        </div>
      
    </div>
</Col>
            </Row>
        </React.Fragment>
    )
}

export default Selected;
